import { FunctionComponent, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./Integration.module.css";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { showSnackbarAction } from "../../Redux/actions";
import { updateWhatsAppIntegration } from "../../Services/organizations";
import { url } from "../../Values/constants";

type props = {
  user: any;
  history: any;
  theme: any;
};

const IntegrationWhatsApp: FunctionComponent<props> = ({
  user,
  history,
  theme,
}) => {

  const dispatcher = useDispatch();

  const handleFacebookLogin = () => {

    if (!window.FB) {
      dispatcher(showSnackbarAction("Facebook SDK not loaded", "error"));
      return;
    }

    window.FB.login(
      async (loginResponse: any) => {

        console.log("FB LOGIN RESPONSE", loginResponse);

        if (!loginResponse.authResponse) {
          dispatcher(showSnackbarAction("Facebook login cancelled", "error"));
          return;
        }

        const code = loginResponse.authResponse.code;

        try {

          const tokenRes = await axios.post(
            url + "/utils/whatsappFacebookToken",
            { code }
          );

          if (!tokenRes.data.success) {
            dispatcher(showSnackbarAction("WhatsApp integration failed", "error"));
            return;
          }

          const response = tokenRes.data.data;

          await updateWhatsAppIntegration(user.organization_id, {
            phone_number_id: response.phone_number_id,
            waba_id: response.waba_id,
            business_name: response.business_name,
            access_token: response.access_token,
            status: "CONNECTED"
          });

          dispatcher(
            showSnackbarAction("WhatsApp connected successfully!", "success")
          );

        } catch (err) {

          dispatcher(showSnackbarAction("Integration failed", "error"));

        }

      },
      {
        config_id: "1470776091338075",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {
            business: {
              name: "Leads Rubix"
            }
          },
          featureType: "whatsapp_embedded_signup"
        }
      }
    );
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  return (
    <>
      <div
        className={styles.parent}
        style={{ ...containerStyles, marginTop: "4%", overflow: "hidden" }}
      >
        <div className="d-flex flex-row w-100" style={{ marginLeft: "2%", marginTop: "24px" }}>
          <a onClick={() => history.push("/integrations")} style={{ cursor: "pointer", textDecoration: "underline" }}>{"Integrations"}</a>
          <ArrowForwardIosIcon fontSize="small" style={{ margin: "0 4px" }} />
          {"WhatsApp"}
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 24px 0 rgba(0,0,0,0.08)",
              width: "600px",
              maxWidth: "95vw",
              padding: "48px 32px 40px 32px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "32px",
              marginBottom: "32px"
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <div style={{ fontSize: "var(--font-size-medium)", fontWeight: 500, marginBottom: 8 }}>
                Automatically create leads in Lead Rubix from your WhatsApp conversations.
              </div>

              <div style={{ fontSize: "var(--font-size-medium)", color: "#444", marginBottom: 12 }}>
                Connect your WhatsApp Business number to capture incoming messages as leads and
                respond directly from your CRM.
              </div>

              <div style={{ fontSize: "14px", color: "#666", marginTop: 12 }}>
                Click on <b>‘Login with Facebook’</b> to set up your WhatsApp auto-responder.
                This will only take a few minutes.
              </div>

              <div style={{ fontSize: "14px", color: "#666", marginTop: 8 }}>
                Make sure to select <b>‘Connect your existing WhatsApp Business App’</b> and
                choose the WhatsApp Business number when prompted by Facebook.
              </div>
            </div>
            <button
              className="bg-brand-fb rounded font-medium py-2 px-3 select-none focus:outline-none focus:ring-0 my-4 text-white"
              style={{
                backgroundColor: "#272944",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "16px",
                fontWeight: 500,
                padding: "12px 32px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0 2px 8px 0 rgba(39,41,68,0.08)",
                cursor: "pointer"
              }}
              onClick={handleFacebookLogin}
            >
              <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: 20, height: 20, marginRight: 10 }}>
                <path fill="currentColor" d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
              </svg>
              Login with Facebook
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
  };
};

export default connect(mapStateToProps)(IntegrationWhatsApp);
